module.exports = __webpack_public_path__ + "static/media/challenge_view.503a0f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/challenge_view.png
// module id = 544
// module chunks = 0